import { css } from 'emotion'

export const ArrowDownIconStyles = css`
  transform: rotate(270deg);
`
